import { useEffect, useLayoutEffect, useMemo, useState } from 'react';

export const useElementSize = (element?: Element) => {
  const [size, setSize] = useState([0, 0]);
  useLayoutEffect(() => {
    function updateSize() {
      const boundaries = element?.getBoundingClientRect();
      if (boundaries) {
        setSize([boundaries.width, boundaries.height]);
      }
    }
    if (element) {
      new ResizeObserver(updateSize).observe(element);
    }
  }, [element]);
  return size;
};
export const useWindowSize = () => {
  const [size, setSize] = useState([0, 0]);
  useLayoutEffect(() => {
    function updateSize() {
      setSize([window.innerWidth, window.innerHeight]);
    }
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);
  return size;
};

export const useResize = (element: any) => {
  const windowSize = useWindowSize();
  const size = useElementSize(element?.canvas?.parentElement);
  useEffect(() => {
    if (element && element.resize !== undefined) {
      setTimeout(() => {
        try {
          element.resize();
        } catch (e) {
          // TODO: Handle error
        }
      }, 500);
    }
  }, [element, size, windowSize]);
};

export const useMediaClassName = () => {
  const size = useWindowSize();

  const className = useMemo(() => {
    const [width] = size;
    if (width === 0) return '';
    if (width >= 1920) {
      return 'media-large';
    }
    if (width >= 1280) {
      return 'media-medium';
    }
    if (width < 1280) {
      return 'media-small';
    }
  }, [size]);
  return className;
};
